'use client';

import { SLA_SEVERITIES, SUPPORT_EMAIL } from 'Bomdisoft/app/[lang]/support/sla-content';
import { LegalPageShell } from 'Bomdisoft/shared/legal-page-shell';
import legal from 'Bomdisoft/shared/legal-page-shell/styles.module.css';
import {
  slaChangesBody,
  slaChangesHeading,
  slaChannelsBody,
  slaChannelsHeading,
  slaExclusionItem1,
  slaExclusionItem2,
  slaExclusionItem3,
  slaExclusionItem4,
  slaExclusionsHeading,
  slaExclusionsIntro,
  slaIntro,
  slaLastUpdated,
  slaNatureBody,
  slaNatureHeading,
  slaResolutionBody1,
  slaResolutionBody2,
  slaResolutionHeading,
  slaSeverityHeading,
  slaSeverityIntro,
  slaTargetsHeading,
  slaTargetsIntro,
  slaTitle,
  slaTitleAccent,
  supportEyebrow,
} from 'Bomdisoft/translations';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';

const SlaPage = () => {
  const params = useParams();
  const language = getLanguageFromLocale(typeof params.lang === 'string' ? params.lang : 'en');

  return (
    <LegalPageShell eyebrow={supportEyebrow[language]} lede={slaLastUpdated[language]} testId='sla-page' title={slaTitle[language]} titleAccent={slaTitleAccent[language]}>
      <section className={legal.section}>
        <div className={legal.content}>
          <p className={legal.body}>{slaIntro[language]}</p>
          <h2 className={legal.sectionHeading}>{slaChannelsHeading[language]}</h2>
          <p className={legal.body}>{slaChannelsBody[language].replace('{email}', SUPPORT_EMAIL)}</p>
          <h2 className={legal.sectionHeading}>{slaSeverityHeading[language]}</h2>
          <p className={legal.body}>{slaSeverityIntro[language]}</p>
          <ul className={legal.list}>
            {SLA_SEVERITIES.map(severity => (
              <li key={severity.level}>
                <span className={legal.strong}>{`${severity.name[language]}:`}</span> {severity.definition[language]}
              </li>
            ))}
          </ul>
          <h2 className={legal.sectionHeading}>{slaTargetsHeading[language]}</h2>
          <p className={legal.body}>{slaTargetsIntro[language]}</p>
          <ul className={legal.list}>
            {SLA_SEVERITIES.map(severity => (
              <li key={severity.level}>
                <span className={legal.strong}>{`${severity.name[language]}:`}</span> {severity.target[language]}
              </li>
            ))}
          </ul>
          <h2 className={legal.sectionHeading}>{slaResolutionHeading[language]}</h2>
          <p className={legal.body}>{slaResolutionBody1[language]}</p>
          <p className={legal.body}>{slaResolutionBody2[language]}</p>
          <h2 className={legal.sectionHeading}>{slaExclusionsHeading[language]}</h2>
          <p className={legal.body}>{slaExclusionsIntro[language]}</p>
          <ul className={legal.list}>
            <li>{slaExclusionItem1[language]}</li>
            <li>{slaExclusionItem2[language]}</li>
            <li>{slaExclusionItem3[language]}</li>
            <li>{slaExclusionItem4[language]}</li>
          </ul>
          <h2 className={legal.sectionHeading}>{slaNatureHeading[language]}</h2>
          <p className={legal.body}>{slaNatureBody[language]}</p>
          <h2 className={legal.sectionHeading}>{slaChangesHeading[language]}</h2>
          <p className={legal.body}>{slaChangesBody[language].replace('{email}', SUPPORT_EMAIL)}</p>
        </div>
      </section>
    </LegalPageShell>
  );
};

export default SlaPage;
